import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, Outlet, useNavigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { AdminProvider, useAdmin } from "./contexts/AdminContext";
import { Layout } from "./components/Layout";
import { LoginPage } from "./pages/LoginPage";
import { NotAuthorizedPage } from "./pages/NotAuthorizedPage";
import { AuthLoadingPage } from "./pages/AuthLoadingPage";
import { HomePage } from "./pages/HomePage";
import { ShopsPage } from "./pages/ShopsPage";
import { ShopDetailPage } from "./pages/ShopDetailPage";
import { PendingPage } from "./pages/PendingPage";
import { AdminsPage } from "./pages/AdminsPage";
import { FreeCodesPage } from "./pages/FreeCodesPage";
import { RegistrationsPage } from "./pages/RegistrationsPage";
import { SubscriptionsPage } from "./pages/SubscriptionsPage";
import { MpesaPaymentsPage } from "./pages/MpesaPaymentsPage";

function LayoutShell() {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}

function AppRoutes() {
  const { isAuthenticated, loading } = useAuth();
  const { actor } = useAdmin();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !isAuthenticated) navigate("/login");
  }, [loading, isAuthenticated, navigate]);

  useEffect(() => {
    if (actor && isAuthenticated) {
      const path = window.location.pathname;
      const isAuthPage = path === "/login" || path === "/not-authorized" || path === "/";
      if (isAuthPage) navigate("/home");
    }
  }, [actor, isAuthenticated, navigate]);

  if (loading) return <AuthLoadingPage />;

  if (isAuthenticated && !actor && window.location.pathname !== "/not-authorized") return <AuthLoadingPage />;

  return (
    <Routes>
      <Route path="/login"          element={<LoginPage />} />
      <Route path="/not-authorized" element={<NotAuthorizedPage />} />

      <Route element={<LayoutShell />}>
        <Route path="/home"       element={<HomePage />} />
        <Route path="/shops"      element={<ShopsPage />} />
        <Route path="/shops/:num" element={<ShopDetailPage />} />
        <Route path="/pending"         element={<PendingPage />} />
        <Route path="/registrations"   element={<RegistrationsPage />} />
        <Route path="/subscriptions"   element={<SubscriptionsPage />} />
        <Route path="/payments"        element={<MpesaPaymentsPage />} />
        <Route path="/admins"          element={<AdminsPage />} />
        <Route path="/free-codes" element={<FreeCodesPage />} />
      </Route>

      <Route path="*" element={<Navigate to={isAuthenticated ? "/home" : "/login"} replace />} />
    </Routes>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AdminProvider>
          <AppRoutes />
        </AdminProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
